import { AuthSelectors } from '@web_opxp/features';
import { all, call, put, select, takeEvery } from 'redux-saga/effects';
import { CouponActions } from './slice';
import { DAY0COUPON, getCouponFromCookies, getCouponFromUrl, isDay0 } from './utils';

export function* handleCouponInit() {
  // get coupon from url
  let coupon: string = yield call(getCouponFromUrl);
  if (coupon) {
    // override day0 coupon if other coupon is present in url
    yield put(CouponActions.couponUpdate(coupon, false));
    return;
  }
  // get coupon from cookies
  coupon = yield call(getCouponFromCookies);
  if (coupon) {
    // override day0 coupon if other coupon is present in cookies
    yield put(CouponActions.couponUpdate(coupon, false));
    return;
  }
  // fallback - check for day 0 coupon
  const isPremium: boolean = yield select(AuthSelectors.isPremium);
  const created: number | undefined = yield select(AuthSelectors.getCreated);
  const isUserDay0: boolean = yield call(isDay0, created);
  const applyDay0Coupon = !isPremium && isUserDay0;
  if (applyDay0Coupon) {
    coupon = DAY0COUPON;
  }
  yield put(CouponActions.couponUpdate(coupon, applyDay0Coupon));
}

export default function* watchCoupon() {
  yield all([takeEvery(CouponActions.couponInit, handleCouponInit)]);
}
